
<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
        <loading
      :active.sync="loading"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>
    <Header />

    <b-card class="bCardGlobal">
      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span
            ><b-icon icon="file-earmark-check" aria-hidden="true"></b-icon
          ></span>
          <span>Bandeja de seguimiento de Avpt </span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>Bandeja de seg_pti</div>
        </b-col>
      </b-row>

      <div class="divSubtitulo">
        <p class="textSubtitulo">Consulta de estatus por Avpt</p>
      </div>
      <b-form  v-if="tipoBusqueda == 1" @submit.stop.prevent="filtrado">
      <div class="row" v-if="$localStorageService.can('Cons_01_avpt_BJ_fecha')">
        <b-col cols="4">
          <validation-provider name="fcInicioVal" :rules="{ required: true }" v-slot="validationContext">
            <label>Fecha inicio de aceptación de PTI:<validacion/></label>
            <b-input-group size="sm" class="mb-2">
              <b-form-datepicker placeholder="Fecha inicio"
                                 :max="new Date()"
                                 @input="fechaMaxima($event)"
              ></b-form-datepicker>
            </b-input-group>
            <b-form-invalid-feedback :state="filtro.fechaInicio != null">
              Este campo es obligatorio
            </b-form-invalid-feedback>
          </validation-provider>
        </b-col>

        <b-col cols="4">
          <validation-provider name="fcFinVal" :rules="{ required: true }" v-slot="validationContext">
            <label>Fecha fin de aceptación de PTI:<validacion/></label>
            <b-input-group size="sm" class="mb-2">
              <b-form-datepicker placeholder="Fecha fin"
                                 v-model="filtro.fechaFin"
                                 :max="maximo()"
                                 :min="filtro.fechaInicio"
              ></b-form-datepicker>
            </b-input-group>
            <b-form-invalid-feedback :state="filtro.fechaFin != null">
              Este campo es obligatorio
            </b-form-invalid-feedback>
          </validation-provider>
        </b-col>
       <!-- <div class="col" v-if="$localStorageService.can('Cons_01_avpt_BJ_status')">
          <b-form-group align="left">
            <label
              >Estatus
            </label>
            <b-input-group size="sm" class="mb-2 row">
              
              <v-select
                class="col-11"
                id="nombreMenu"
                name="nombreMenu"
                placeholder="Estatus"
                v-model="idEstatusFiltro"
                label="nombreEstatus"
                style="width: 95%"
                required
                :reduce="(variable) => variable.idEstatus"
                :options="colores"
                multiple
              >
                <template v-slot:option="option">
                  <em class="fa fa-circle" :style="{ color: option.codigoColor }">
                  </em>
                  {{ option.nombreEstatus }}
                </template>
              </v-select>
            </b-input-group>
            
          </b-form-group>
        </div>-->
        <div class="col" v-if="$localStorageService.can('Cons_01_avpt_BJ_status_tx')">
          <b-form-group align="left">
            <label
            >Estatus Tx
            </label>
            <b-input-group size="sm" class="mb-2 row">

              <v-select
                  class="col-11"
                  id="nombreMenu"
                  name="nombreMenu"
                  placeholder="Estatus"
                  v-model="idEstatusFiltroTx"
                  label="nombre"
                  style="width: 95%"
                  required
                  :reduce="(variable) => variable.value"
                  :options="coloresTx"
                  multiple
              >
                <template v-slot:option="option">
                  <em class="fa fa-circle" :style="{ color: option.codigoColor }">
                  </em>
                  {{ option.nombre }}
                </template>
              </v-select>
            </b-input-group>

          </b-form-group>
        </div>
      </div>

      <div class="row">
        <div class="col-10" v-if="$localStorageService.can('Cons_01_avpt_BJ_clini')">
          <b-form-group align="left">
            <label>Clínicas</label>
            <v-select
              style="width: 100%"
              name="clinica"
              placeholder="--Seleccionar--"
              label="nombreClinica"
              multiple
              :reduce="(variable) => variable.idClinica"
              :options="listaClinicas"
              v-model="filtro.clinica"
              ><span slot="no-options">No hay clínicas disponibles</span>
            </v-select>
          </b-form-group>
           <b-form-invalid-feedback :state="filtro.clinica != null && filtro.clinica.length > 0 ">
                  Este campo es obligatorio
                </b-form-invalid-feedback>
        </div>
        <div class="col-2 mt-4" v-if="$localStorageService.can('Cons_01_avpt_BJ_add_clin')">
          <b-button
            v-if="todas"
            class="btnn"
            variant="outline-primary"
            v-b-tooltip.hover
            @click="todos()"
          >
            <b-icon icon="check2-all"></b-icon>
            <span class="labels">Seleccionar Todas</span>
          </b-button>
          <b-button
            v-else
            class="btnn"
            variant="outline-primary"
            v-b-tooltip.hover
            @click="clear()"
          >
            <b-icon icon="x"></b-icon>
            <span class="labels">Quitar todas</span>
          </b-button>
        </div>
      </div>
      
      <div>
        <b-button class="m-5" variant="outline-primary" type="submit"  v-if="$localStorageService.can('Cons_01_avpt_BJ_btn_busc')"
          >Buscar</b-button
        >
      </div>

      </b-form>
      <b-row v-if="tipoBusqueda == 2 || tipoBusqueda == 3">
        <b-col  >
          <div class="d-flex justify-content-center">
            <b-row class="barra d-flex justify-content-between">
              <div class="col-sm-12 col-md-4 d-flex text-left">
                <font-awesome-icon
                    style="color: gray"
                    class="m-auto m-1"
                    icon="filter"
                />
                <b-form-input
                  v-if="tipoBusqueda == 2"
                    class="ml-3 input-filter"
                    style="border:0"
                    placeholder="ID de PTI"
                    v-model="filtro.idPTI"
                ></b-form-input>
                <b-form-input
                  v-if="tipoBusqueda == 3"
                    class="ml-3 input-filter"
                    style="border:0"
                    placeholder="ID del paciente"
                    v-model="filtro.idPaciente"
                ></b-form-input>
              </div>

         
              <div class="col-md-1  col-sm-12 text-right">
                <b-button
                    variant="primary"
                    :disabled="loader"
                    @click="filtrado(true)"
                >
                  <span v-if="!loader"
                  ><font-awesome-icon icon="search"
                  /></span>
                  <span v-else><b-spinner small></b-spinner></span>
                </b-button>
              </div>
            </b-row>
          </div>
        </b-col>
      </b-row>  


      <b-form-group v-slot="{ ariaDescribedbyTipoBusqueda }">
        <b-form-radio-group
            id="btn-tipos_busqueda_paciente"
            v-model="tipoBusqueda"
            :aria-describedby="ariaDescribedbyTipoBusqueda"
            button-variant="outline-primary"
            size="sm"
            name="radio-btn-outline"
        >
        <b-form-radio value="1" v-if="$localStorageService.can('Cons_01_avpt_BJ_fecha')" @change="cambioFiltro(1)">Busq. por fechas</b-form-radio>
        <b-form-radio value="2" v-if="$localStorageService.can('Cons_01_avpt_idpti')" @change="cambioFiltro(2)">Busq. por ID de PTI</b-form-radio>
        <b-form-radio value="3" v-if="$localStorageService.can('Cons_01_avpt_idpx')" @change="cambioFiltro(3)">Busq. por ID de paciente</b-form-radio>
      </b-form-radio-group>
      </b-form-group>
<!--      Inico de la tabla AVPT Bandeja-->

      <b-table
        id="Pendientes"
        :sticky-header="true"
        thead-tr-class="columnas"
        :items="datosTabla"
        :fields="fields"
        class="parrafos mt-4"
        @filtered="onFiltered"
      >
      
      <template v-slot:cell(nombrePaciente)="row">
        <router-link
                :to="{ name: 'avpt', params: { idPaciente: row.item.idPaciente } }"
            >
              <div class="spanCien">
                <span
                    v-if="row.item.nombrePaciente != null"
                    style="color: #087372"
                >
                  {{ row.item.nombrePaciente }}
                </span>
                <span v-else style="color: #000000">
                  {{ row.item.nombrePaciente }}
                </span>
              </div>
            </router-link>
      </template>
        <template v-slot:cell(clasificacion)="row">
          {{ row.item.clasificacion }}
          <b-icon
            icon="star-fill"
            aria-hidden="true"
            font-scale="1.5"
            :style="{ color: row.item.colorClasificacion }"
          ></b-icon>

        </template>
        <template v-slot:cell(estatus)="row">
          <b-icon
              v-b-tooltip.hover
              :title=" ' Estatus tratamiento' "
              icon="circle-fill"
              aria-hidden="true"
              font-scale="2"
              :style="{ color: row.item.colorEstatus }"
          ></b-icon>
        </template>
        <template v-slot:cell(colorEstatusPti)="row">
          <b-icon
              v-b-tooltip.hover
              :title=" ' Estatus general pti ' "
              icon="circle-fill"
              aria-hidden="true"
              font-scale="2"
              :style="{ color: row.item.colorEstatusPti }"
          ></b-icon>
        </template>
        <template v-slot:cell(fechaProgramada)="row">
          <div v-if="row.item.fechaProgramada != null && row.item.fechaProgramada != ''" >
            {{ row.item.fechaProgramada }}
          </div>
          <div v-else>
            <p>Sin fecha</p>
          </div>
        </template>
        <template v-slot:cell(fechaActividadAsignada)="row">
          {{row.item.fechaActividadAsignada | formatoFechaHora}}
        </template>
        <template v-slot:cell(ultimoTratamiento)="row">
          <p v-if="row.item.ultimoTratamiento != null && row.item.ultimoTratamiento != ''">{{row.item.ultimoTratamiento}}</p>
          <p v-else>Sin inicio de tratamiento</p>
        </template>
        <template v-slot:cell(noContactar)="row">
            <b-button pill variant="info" @click="enviarNoContacto(row.item)">No contactar</b-button>
            <b-form-group align="center">
              
              
            </b-form-group>
        </template>

        <template v-slot:cell(programarActividad)="row" v-if="$localStorageService.can('Cons_01_avpt_BJ_progAct')">
          <b-button :disabled="row.item.desactivarBotonActividad != null && row.item.desactivarBotonActividad" pill variant="info" @click="programarActivdiad(row.item)">Actividad</b-button>
        </template>

        <template v-slot:cell(actividadRealizada)="row" v-if="$localStorageService.can('Cons_01_avpt_BJ_Act_reali')">
          <b-icon
              icon="clock-history" scale="2"
              variant="success" v-b-popover.hover.top="'Historial de acciones'"
              @click="
              obtenerHistoricoAccionesBandejaAvpt(
                row.item.idSolicitudBandejaAvpt, true
              )
            "
              class="mLeft">
          </b-icon>
        </template>
        <template v-slot:cell(proximaCita)="row">
          <div v-if="row.item.proximaCita != null && row.item.proximaCita != ''" >
            {{ row.item.proximaCita }}
          </div>
          <div v-else>
            <p>Sin fecha</p>
          </div>

        </template>
        <template v-slot:cell(porcentajeFinanciero)="row">
          <span>{{ row.item.porcentajeFinanciero }}%</span>
        </template>
        <template v-slot:cell(avanceSalud)="row">
          <span>{{ row.item.avanceSalud }}%</span>
        </template>
         <div align="center" v-if="loader">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </div>
      </b-table>
       <b-col v-if="!loader">
            <b-alert v-if="datosTabla.length === 0" variant="warning" show
              >No se encontraron datos</b-alert
            >
          </b-col>
      <b-pagination
              align="center"
              v-model="paginaActual"
              :total-rows="totalNuevos"
              :per-page="registrosPorPagina"
              aria-controls="my-table1"
              @input="onPageChange"
            ></b-pagination>
    </b-card>



    <b-modal
        size="lg"
        v-model="programarActivdadesEnviar"
        id="modalAcciones"
        title="Acciones a realizar"
        :hide-footer="true"
        :no-close-on-backdrop="true"
    >
      <div>
        <div>
          <label style="width: 100%">
            <b-row style="width: 100%">
              <b-col cols="6">Acción a ejecutar: <validacion /></b-col>
              <b-col cols="6" align="right"> </b-col>
            </b-row>
          </label>
        </div>
        <div>
          <v-select
              :options="listaAccion"
              v-model="enviarAcciones.idAccion"
              label="nombre"
              :reduce="(variable) => variable.idAccion"
              :state="enviarAcciones.idAccion != null"
          >
            <span slot="no-options">No hay coincidencias.</span>
          </v-select>
          <b-form-invalid-feedback :state="enviarAcciones.idAccion != null">
            Se debe escoger una acción
          </b-form-invalid-feedback>

        </div>

        <div>
          <label style="width: 100%">
            <b-row style="width: 100%">
              <b-col cols="6">Empleado: <validacion /></b-col>
              <b-col cols="6" align="right"> </b-col>
            </b-row>
          </label>
        </div>
        <div>
          <v-select
              :options="datosEmpeladosPerfiles"
              v-model="datosEmpeladosPerfiles.idEmpleado"
              label="nombre"
              :reduce="(variable) => variable.idEmpleado"
              :state="datosEmpeladosPerfiles.idEmpleado != null"
          >
            <span slot="no-options">No hay coincidencias.</span>
          </v-select>
          <b-form-invalid-feedback :state="datosEmpeladosPerfiles.idEmpleado != null">
            Se debe escoger una acción
          </b-form-invalid-feedback>
        </div>

      
        <div>
          <label style="width: 100%">
            <b-row style="width: 100%">
              <b-col cols="6">Observaciones: <validacion /></b-col>
              <b-col cols="6" align="right"> </b-col>
            </b-row>
          </label>
        </div>
        <div>
          <b-form-textarea
                    id="textarea"
                    placeholder="Ingresa tus observaciones..."
                    rows="3"
                    max-rows="6"
                    v-model="enviarAcciones.comentario"
                    :state="enviarAcciones.comentario != null && enviarAcciones.comentario != ''"
                ></b-form-textarea>
                <b-form-invalid-feedback :state="enviarAcciones.comentario != null && enviarAcciones.comentario != ''">
                  Debe de escribir observaciones
                </b-form-invalid-feedback>

        </div>
          
        <div style="padding:15px;" class="float-right">
          <b-button   pill
                      variant="info"
                      :disabled="
                       enviarAcciones.idAccion == null ||
                      datosEmpeladosPerfiles.idEmpleado == null || 
                      enviarAcciones.comentario == null ||
                      btnDisabled == true ||
                      loader
                      "

                      @click="guardarHistoricoAcciones(datosEmpeladosPerfiles.idEmpleado, true)">Guardar
                      <span v-if="loader"><b-spinner small></b-spinner></span></b-button>
        </div>

      </div>
    </b-modal>

    <b-modal
        size="lg"
        v-model="modalEnviarNoContacto"
        id="modalAcciones"
        title="No contactar paciente"
        :hide-footer="true"
        :no-close-on-backdrop="true"
    >
      <div>
        <div>
          <label style="width: 100%">
            <b-row style="width: 100%">
              <b-col cols="6">Razón para no contactar a px: <validacion /></b-col>
              <b-col cols="6" align="right"> </b-col>
            </b-row>
          </label>
        </div>
        <div>
          <b-input-group size="sm" class="mb-2 row">
            <v-select
            v-if="fieldPaciente != null"
            :disabled="fieldPaciente.desactivarBotonActividad != null && fieldPaciente.desactivarBotonActividad"
              class="col-11"
              placeholder="Razones"
              v-model="enviarAcciones.idAccion"
              label="descripcion"
              :reduce="(variable) => variable.idAccionBandejaAvpt"
              :options="razonesNoContacto"
            >
            </v-select>
          </b-input-group>
          <b-form-invalid-feedback :state="enviarAcciones.idAccion != null">
            Se debe escoger una acción
          </b-form-invalid-feedback>

        </div>

        <div>
          <label style="width: 100%">
            <b-row style="width: 100%">
              <b-col cols="6">Observaciones: <validacion /></b-col>
              <b-col cols="6" align="right"> </b-col>
            </b-row>
          </label>
        </div>
        <div>
          <b-form-textarea
          v-if="fieldPaciente != null"
          :disabled="fieldPaciente.desactivarBotonActividad != null && fieldPaciente.desactivarBotonActividad"
                    id="textarea"
                    placeholder="Ingresa tus observaciones..."
                    rows="3"
                    max-rows="6"
                    v-model="enviarAcciones.comentario"
                    :state="enviarAcciones.comentario != null && enviarAcciones.comentario != ''"
                ></b-form-textarea>
                <b-form-invalid-feedback :state="enviarAcciones.comentario != null && enviarAcciones.comentario != ''">
                  Debe de escribir observaciones
                </b-form-invalid-feedback>

        </div>
        <b-form-checkbox v-if="fieldPaciente != null" :disabled="fieldPaciente.desactivarBotonActividad != null && !fieldPaciente.desactivarBotonActividad" v-model="checkContactar" >
          Contactar
        </b-form-checkbox>
        <div style="padding:15px;" class="float-right">
          <b-button   pill
                      variant="info"
                      :disabled="
                      btnDisabled == true ||
                      loader
                      "

                      @click="guardarHistoricoAcciones(datosEmpeladosPerfiles.idEmpleado, false)">Guardar
                      <span v-if="loader"><b-spinner small></b-spinner></span></b-button>
        </div>

      </div>
    </b-modal>

    <!--    Modal del Historico de Acciones -->

    <b-modal
        size="xl"
        v-model="mostrarModalHistoricoAcciones"
        id="historicoAcciones"
        title="Histórico acciones ejecutadas"
        :hide-footer="true"
        :no-close-on-backdrop= true
    >
      <div>
        <div>
          <div>
            <b-table
            id="my-table1"
                thead-tr-class="columnas"
                :items="listaHistoricoAccionesIndexAgregado"
                :fields="fieldsHistorico"
                :current-page="currentPage"
                :per-page="perPage"
                sticky-header
                empty-text="No se encontraron registros"
                show-empty
            >
              <template v-slot:cell(fechaAlta)="row">
                {{row.item.fechaAlta | formatoFechaHora}}
              </template>
              <template v-slot:cell(observacionCC)="row">
                <div  v-if="row.item.observacionCC != null && row.item.observacionCC.length > 17">
                  <b-button
                  title="Detalle de observaciones"
                  size="sm"
                  @click="
                    abrirModal(row.item.observacionCC)
                  "
                  variant="info"
                  ><em class="fa fa-eye"></em
                ></b-button>
                </div>
                
                <div v-else>
                  {{row.item.observacionCC}}
                </div>
              </template>
              <template v-slot:cell(observacionAnfi)="row">
                <div  v-if="row.item.observacionAnfi != null && row.item.observacionAnfi.length > 43 && row.item.idTipoAccion == 1">
                  <b-button
                  title="Detalle de observaciones"
                  size="sm"
                  @click="
                    abrirModal(row.item.observacionAnfi)
                  "
                  variant="info"
                  ><em class="fa fa-eye"></em
                ></b-button>
                </div>
                <div v-else>
                  {{row.item.observacionAnfi}}
                </div>
               
                
              </template>
            </b-table>
            <b-pagination
            v-if="totalHistorico > 5"
            v-model="currentPage"
            :total-rows="totalHistorico"
            :current-page="currentPage"
            :per-page="perPage"
            align="center"
            aria-controls="my-table1"
          ></b-pagination>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal
        v-model="modalComentarios"
        title="Observaciones"
        scrollable
        size="lg"
      >
        <p style="font-size: 18px; font-weight: 600">Observaciones de la actividad</p>
        <div class="container-fluid main-component p-3 text-justify">
          <p>{{ seleccionObservaciones }}</p>
        </div>
      </b-modal>

  </div>
</template>

<script>
import Header from "@/components/Header";
import { required } from "vuelidate/lib/validators";
import XLSX from 'xlsx';
export default {
  name: "BandejaSeguimiento",
  components: { Header },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    registrosPorPagina: 20,
    paginaActual: 1,
    
    idRazonNoContacto: null,
    modalComentarios: false,
    tipoBusqueda: 0,
    diasMaximoMes: null,
    btnDisabled: false,
    mostrarModalHistoricoAcciones:false,
    listaHistoricoAcciones:[],
    listaHistoricoAccionesIndexAgregado:[],
    datosEmpeladosPerfiles:[{
      idEmpleado:null
    }],
    idClinica:null,
    banderaExito:false,
    programarActivdadesEnviar:false,
    loading:false,
    filtro: {
      fechaInicio: null,
      fechaFin: null,
      idEstatus: [],
      clinica: [],
      idPaciente: null,
      idPTI: null,
      idEstatusTx: []
    },
    listaClinicas: [],


    datosTabla: [],
    listaAccion:[
      {
      idAccion: '1',
      nombre:'Mail'
      },
      {
        idAccion: '2',
        nombre:'WhatsApp'
      },
      {
        idAccion: '3',
        nombre:'Llamada'
      },
    ],

    enviarAcciones:{
      idAccion:null,
      comentario:null,
      idSolicitudBandejaAvpt: null,
      idEmpleado:null,
      idPaciente: null,
      cc: true,
      idEstatus: 1
    },


    sla: {
      idSla: null,
      idTipoSolicitud: null,
      sla: null,
      idEstatus: null,
      registroActivo: null,
    },
    tituloModal: "",
    show: false,
    modalAgregarEstatus: false,
    loader: false,
    modalEnviarNoContacto: false,
    fields: [
    { key: "fechaAceptacionPTI", label: "Fecha de aceptación PTI", sortable: true},
      { key: "clasificacion", label: "Clasificación PTI", sortable: true },
      { key: "colorEstatusPti", label: "Estatus general Pti", sortable: true },
      { key: "estatus", label: "Estatus tratamiento", sortable: true },
      { key: "strclinica", label: "Clinica", sortable: true },
      { key: "idPaciente", label: "Id Paciente", sortable: true },
      { key: "nombrePaciente", label: "Paciente", sortable: true },
      { key: "ultimaCita", label: "Ultima cita", sortable: true },
      { key: "proximaCita", label: "Proxima Cita", sortable: true },
      { key: "ultimoTratamiento", label: "Ultimo Tratamiento", sortable: true },
      { key: "proximoTratamiento", label: "Proximo Tratamiento", sortable: true },
      { key: "fechaProgramada", label: "Fecha Programada", sortable: true },
      { key: "doctorAsignado", label: "Doctor Asignado", sortable: true },
      { key: "programarActividad", label: "Programar Actividad", sortable: true },
      { key: "fechaActividadAsignada", label: "Fecha de asignación actividad", sortable: true },
      { key: "actividadRealizada", label: "Actividades programadas", sortable: true },
      { key: "porcentajeFinanciero", label: "% AVPT Tx Financiero", sortable: true },
      { key: "avanceSalud", label: "% AVPT Tx", sortable: true },
      { key: "noContactar", label: "No contactar", sortable: true, thStyle: { width: "10%" } },



    ],

    fieldsHistorico: [
      { key: "id", label: "Núm.", sortable: true },
      { key: "fechaAlta", label: "Fecha de asignación", sortable: true },
      { key: "empleadoAccion", label: "Colaborador que realiza acción", sortable: true },
      { key: "accion", label: "Acción", sortable: true },
      { key: "observacionCC", label: "Observaciones CC", sortable: true },
      { key: "observacionAnfi", label: "Observaciones clínica", sortable: true },
      { key: "estatus", label: "Estatus", sortable: true },
      
    ],
    
    currentPage: 1,
    perPage: 5,
    totalRows: 1,
    totalNuevos: null,
    totalHistorico: null,
    colores: [],
    tiposSolicitud: [],
    loaderAcciones: false,
    datosGuardar: {
      idEstatus: null,
      nombreEstatus: null,
      proximaCita: true,
      slaMinimo: null,
      slaMaximo: null,
      registroActivo: true,
    },
    idEstatusFiltro: null,
    idPTI: null,
    idPaciente: null,
    datosExportar: [],
    dataExcel:[],
    todosIdEstatus: [],
    todas: true,
    buscar: false,
    seleccionObservaciones: null,
    razonesNoContacto: [],
    isActividad: false,
    checkContactar: false,
    fieldPaciente: null,
    coloresTx: [
      {value: 1, nombre: "En tiempo", codigoColor: "#4CA23E"},
      {value: 2, nombre: "Por Vencer", codigoColor:  "#FBB917"},
      {value: 3, nombre: "Vencido", codigoColor: "#ff0000"},
      {value: 4, nombre: "PTI Finalizado", codigoColor: "#CCCCCC"}
    ],
    idEstatusFiltroTx: null
  }),
  validations: {
    sla: {
      idTipoSolicitud: { required },
      sla: { required },
      idEstatus: { required },
    },
  

  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.idClinica = this.$localStorageService.getIdClinica();
    this.loading=true;
    this.obtenerColores();
    this.llenarClinicas();
    this.obtenerRazonesNoContacto();
    this.clear();
  },
  methods: {
    onFiltered(filteredItems) {
      this.isBusy = true;
      this.totalRows = filteredItems.length;
      setTimeout(() => (this.isBusy = false), 3000);
      this.currentPage = 1;
    },
    obtenerRazonesNoContacto(){
      this.$http
          .get(
            this.$api +
              "seguimiento/bandejaAvpt/obtenerAccionesNoContactarPx").then((respuesta) => {
                this.razonesNoContacto = respuesta.data.data;

              })
    },
    abrirModal(observaciones){
      this.modalComentarios = true;
      this.seleccionObservaciones = observaciones;
    },
    setearDatos(){
      this.filtro= {
      fechaInicio: null,
      fechaFin: null,
      idEstatus: [],
      clinica: [],
      idPaciente: null,
      idPTI: null
    };
    },
    fechaMaxima(event){
      this.diasMaximoMes = this.$moment(event).daysInMonth();
      this.filtro.fechaInicio = new Date(event);
      this.filtro.fechaFin = null;

    },
    programarActivdiad(item){
      this.datosEmpeladosPerfiles = [];
      this.enviarAcciones.idSolicitudBandejaAvpt=item.idSolicitudBandejaAvpt;
      this.enviarAcciones.idPaciente = item.idPaciente;
      this.programarActivdadesEnviar = true;
      this.obtenerEmpleadosPerfiles(item.clinica);
    },

    enviarNoContacto(item){
      this.datosEmpeladosPerfiles = [];
      this.enviarAcciones.idSolicitudBandejaAvpt=item.idSolicitudBandejaAvpt;
      this.enviarAcciones.idPaciente = item.idPaciente;
      this.fieldPaciente = item;
      this.obtenerHistoricoAccionesBandejaAvpt(item.idSolicitudBandejaAvpt,false);
      this.mostrarModalHistoricoAcciones=false;
      this.modalEnviarNoContacto = true;
      this.obtenerEmpleadosPerfiles(item.clinica);
    },

    consultarReporte(){
      this.$swal.fire({
            title: "Este proceso podría tardar varios minutos, ¿desea continuar?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar",
            showLoaderOnConfirm: true,
            preConfirm: () => {
              this.loading = true;
              this.$http
          .post(
            this.$api +
              "seguimiento/bandejaAvpt/obtenerLstBandejaAvptExcel", this.filtro).then((respuesta) => {
                if (respuesta.status === 200) {

                  this.dataExcel =  respuesta.data.data.datosBandeja;
                  this.exportarExcel();
                }
                
              
              }).catch((error) => {
                console.error(error);
                this.$swal.fire({
                    icon: "error",
                    title: "Aviso",
                    text: "Ocurrió un error al consultar la información, por favor intente más tarde",
                  });
                  this.loading = false;
              })

              
             
            },
            allowOutsideClick: () => !this.$swal.isLoading(),
          });

     
    },
     exportarExcel() {
      const fecha = this.$moment(new Date()).format('l')
      const newDate = fecha.split("/")
      var dia = newDate[0];
      var mes = newDate[1];
      var anio = newDate[2];

       let datosExcel = [];
       this.dataExcel.forEach(element => {

         let datos = {
           "Clasificación": element.clasificacion,
           "Estatus General Pti": element.estatus,
           "Estatus Tratamiento": element.estatusTx,
           "Clínica":element.strclinica,
           "ID de paciente":element.idPaciente.toString(),
           "Nombre de paciente": element.nombrePaciente,
           "Última cita": element.ultimaCita === null ? 'Sin fecha' : element.ultimaCita,
           "Próxima cita": element.proximaCita === null ? 'Sin fecha': element.proximaCita ,
           "Último tratamiento":element.ultimoTratamiento,
           "Próximo tratamiento": element.proximoTratamiento,
           "Fecha programada": element.fechaProgramada === null ? 'Sin fecha': element.fechaProgramada,
           "Doctor asignado": element.doctorAsignado,
           "Fecha de asignación actividad": element.fechaActividadAsignada === null ?'Sin fecha': this.$moment(new Date(element.fechaActividadAsignada)).format('ll'),
           "Actividad asignada": element.comentarioActividadAsignada,
           "Actividad realizada": element.idEstatusAccion == 1 ? 'No' : 'Sí',
           "Porcentaje AVPT Tx financiero": element.porcentajeFinanciero + '%',
           "Porcentaje AVPT Tx":element.avanceSalud + '%'
         }
         datosExcel.push(datos);

       });
      let data = XLSX.utils.json_to_sheet(datosExcel)
      const workbook = XLSX.utils.book_new()
      const filename = 'seguimiento_avpt_'+dia+'_'+mes+'_'+anio;
      XLSX.utils.book_append_sheet(workbook, data, filename)
      XLSX.writeFile(workbook, `${filename}.xlsx`)
      this.loading = false;
    },
    onPageChange(){
      this.filtrado(false);
    },
    filtrado(buscar) {
      buscar ? this.paginaActual = 1 : this.paginaActual;

      this.datosTabla = [];

      if (this.tipoBusqueda == 1 && (this.filtro.fechaInicio == null || this.filtro.fechaFin == null || this.filtro.clinica.length == 0)) {
         this.$swal.fire({
            icon: "error",
            title: "Aviso",
            text: "Todos los campos son obligatorios, por favor verifique la información",
          });
     
      }else{
        this.loader=true;
      this.loading=true;
        this.filtro.fechaInicio =
        this.filtro.fechaInicio !== null
          ? this.$moment(this.filtro.fechaInicio).utc().format(
              "YYYY-MM-DD"
            )
          : null;
        this.filtro.fechaFin =
        this.filtro.fechaFin !== null
          ? this.$moment(this.filtro.fechaFin).utc().format("YYYY-MM-DD")
          : null;


          if (this.idEstatusFiltro != null) {
            this.filtro.idEstatus = this.idEstatusFiltro;
          }else{
            this.filtro.idEstatus = this.todosIdEstatus
          }
       

        this.filtro.idsClinica = this.filtro.clinica;
        this.filtro.idEstatusTx =  this.idEstatusFiltroTx;
      this.$http
        .post(
          this.$api +
            "seguimiento/bandejaAvpt/obtenerLstBandejaAvpt?pagina=" + this.paginaActual, this.filtro,  ).then((respuesta) => {

          if (respuesta.data.data) {
            this.datosTabla = respuesta.data.data.datosBandeja;
             /* this.datosExportar=JSON.parse(JSON.stringify(this.datosTabla)); */
             /*this.datosTabla.forEach(element => {
              let fechaFechaRealizacion = null;
            
                  let fechaTemp = element.fechaAceptacionPTI.split("T", 1)
                  let fechaArray = fechaTemp[0].split("-",3)
                  let dia = fechaArray[2]
                  let mes = fechaArray[1]
                  let anio = fechaArray[0]
                  fechaFechaRealizacion = dia + "/" + mes + "/" + anio
                  element.fechaAceptacionPTI = fechaFechaRealizacion
                  element.noContactar = "";
             });*/
            

            this.totalNuevos = respuesta.data.data.total
            this.buscar = true;
          }
        })
        .finally(() => {
          this.loading=false;
          this.loader = false;
        });
      }
    },
    todos() {
      this.todas = false;
      this.listaClinicas.forEach(element => {
        this.filtro.clinica.push(element.idClinica);
      });
    },

    clear() {
      this.todas = true;
      this.filtro.clinica = [];
      this.loading=false;
    },
    llenarClinicas() {
      this.listaClinicas = this.$localStorageService.getClinicas();
    },

    resetearDatos() {
      this.datosGuardar = {
        idEstatus: null,
        nombreEstatus: null,
        proximaCita: true,
        slaMinimo: null,
        slaMaximo: null,
        idColor: 0,
        registroActivo: true,
      };
    },
    obtenerEstatus() {
      this.loader = true;
      this.$http
        .get(this.$api + "seguimiento/bandejaAvpt/obtenerListaBandeja")
        .then((respuesta) => {
          if (respuesta.data.data) {
            this.datosTabla = respuesta.data.data;
          }
        })
        .finally(() => {
          this.loader = false;
        });
    },

      obtenerColores() {
             this.$http
        .get(this.$api + "seguimiento/bandejaAvpt/obtenerEstatusBandeja")
        .then((respuesta) => {
          if (respuesta.data.data) {
            this.colores = respuesta.data.data;
            this.colores.forEach(element => {
              this.todosIdEstatus.push(element.idEstatus);
            });
           
          }
        });
    },
    guardarHistoricoAcciones(idEmpleado, isActividad) {
      let idPaciente = this.enviarAcciones.idPaciente;
      let idSolicitudBandejaAvpt = this.enviarAcciones.idSolicitudBandejaAvpt;
  
      if(!isActividad && this.checkContactar){
        this.enviarAcciones = {
          cc: false,
          comentario: "",
          idAccion: this.listaHistoricoAccionesIndexAgregado[0].idAccion,
          idDetalleAccionBandejaAvpt: this.listaHistoricoAccionesIndexAgregado[0].idAccionBandejaAvpt,
          idEstatus: 2,
          idPaciente: idPaciente,
          idSolicitudBandejaAvpt: idSolicitudBandejaAvpt,
        }
      }
      this.mostrarModalHistoricoAcciones = false;
      if(this.enviarAcciones.comentario.trim() == '' && this.checkContactar == false){
        this.$swal.fire({
        position: "center",
        icon: "warning",
        title: "Los comentarios no pueden ir vacíos",
        showConfirmButton: true
      });
      }else{ 
        this.loading = true;
        this.loader = true;
        if(isActividad){
          this.enviarAcciones.idEmpleado = idEmpleado;
        }else{
          this.enviarAcciones.idEmpleado = 0;
        }
        
        this.$http
          .post(this.$api + "avpt/guardarHisricoAcciones",this.enviarAcciones)
          .then((respuesta) => {
            if (respuesta.data.data) {
              this.banderaExito = respuesta.data.data;
              this.programarActivdadesEnviar = false;
              this.filtrado();
              this.modalEnviarNoContacto = false;
              this.formatearModal();
              this.showAlert();
            }
          }).finally(()=>{
            this.loading= false;
            this.loader = false;
            this.filtrado(true);
            
            
            this.modalEnviarNoContacto = false;
      });
      }
    },

    formatearModal(){
      this.enviarAcciones = {
        idAccion:null,
        comentario:null,
        idSolicitudBandejaAvpt: null,
        idEmpleado:null,
        idPaciente: null,
        cc: true,
        idEstatus: 1
      };
      this.checkContactar = false;
    },

    maximo(){
      if (this.filtro.fechaInicio === null){
        return new Date();
      }
     return this.filtro.fechaInicio.addDays(this.diasMaximoMes) > new Date() ? new Date(): this.filtro.fechaInicio.addDays(this.diasMaximoMes)
    },


    validateState(name) {
      const { $dirty, $error } = this.$v.sla[name];
      return $dirty ? !$error : null;
    },
    selectClass(attribute) {
      let state = this.validateState(attribute);
      if (state) {
        return "border rounded-lg border-success";
      } else if (state === false) {
        return "border rounded-lg border-danger";
      } else {
        return "";
      }
    },
    obtenerEmpleadosPerfiles(clinica) {
      this.loader = true;
      const parametros = {idClinica: clinica}
      this.$http
          .post(this.$api + "seguimiento/bandejaAvpt/encontrarClinicaEmpleadoBandejaAvpt", parametros)
          .then((respuesta) => {
            if (respuesta.data.data) {
              //this.datosEmpeladosPerfiles = respuesta.data.data;
              this.datosEmpeladosPerfiles.push(
                  ...respuesta.data.data
                      .map((it) => {
                        return {
                          idEmpleado: it.idEmpleado,
                          nombre:
                              it.nombreEmpleado +
                              " (" +
                              it.descricionPerfil
                              + ")",
                        };
                      }));
            }
          })
          .finally(() => {
            this.loader = false;
          });
    },
    showAlert() {
      this.$swal.fire({
        position: "center",
        icon: "success",
        title: "Se guardó con éxito",
        showConfirmButton: true
      });
    },
    obtenerHistoricoAccionesBandejaAvpt(idSolicitud, isHistorialActividad){
      this.$http
          .get(this.$api + "avpt/obtenerHistoricoAccionesBandejaAvpt?idSolicitudBandeja=" + idSolicitud)
          .then((respuesta) => {
            if (respuesta.data.data) {
              this.listaHistoricoAcciones = respuesta.data.data;
              this.listaHistoricoAccionesIndexAgregado = [];
              let tamanio = 1
              let ids = [];
              this.listaHistoricoAcciones.forEach(f => {
                if(!ids.includes(f.idAccionBandejaAvpt)){
                  ids.push(f.idAccionBandejaAvpt);
                  const result = this.listaHistoricoAcciones.filter(accion => accion.idAccionBandejaAvpt == f.idAccionBandejaAvpt);  
                  let resultCC = result.filter(obj => obj.estatus == 'Nuevo');
                  let resultAnfi = result.filter(obj => obj.estatus == 'Atendido');
                  /* const indexCC = (result.findIndex(resultCC))
                  const indexAnfi = (result.findIndex(resultAnfi)) */
                  let observacionAnfi = '';
                  if(resultCC[0].idTipoAccion == 1 && resultAnfi[0] != undefined){
                    observacionAnfi = resultAnfi[0].descripcion
                  }else if(resultCC[0].idTipoAccion == 2){
                    observacionAnfi = 'Esta acción es de tipo "no contactar", no hay observaciones de clínica'
                  }else if(resultAnfi[0] == undefined && resultCC[0].idTipoAccion == 1){
                    observacionAnfi = 'El colaborador aún no realiza observaciones'
                  }

                  let accion = {
                    id: tamanio,
                    fechaAlta: resultCC[0].fechaAlta,
                    accion: resultCC[0].accion,
                    idAccion: resultCC[0].idAccion,
                    estatus: resultAnfi[0] != undefined ? resultAnfi[0].estatus : resultCC[0].estatus,
                    empleadoAccion : resultCC[0].empleadoAccion,
                    idAccionBandejaAvpt : result[0].idAccionBandejaAvpt,
                    idTipoAccion : result[0].idTipoAccion,
                    observacionCC : resultCC[0].descripcion,
                    observacionAnfi :observacionAnfi,
                    
                    
                  }           
                  tamanio++;
                  this.listaHistoricoAccionesIndexAgregado.push(accion);
                  this.totalHistorico = this.listaHistoricoAccionesIndexAgregado.length
                }
                /* this.listaHistoricoAccionesIndexAgregado.push({
                  id: tamanio,
                  descripcion: f.descripcion,
                  comentario: f.comentario != '' ? f.comentario : 'Sin observaciones',
                  fechaAlta: f.fechaAlta,
                  idAccion: f.idAccion,
                  idSolicitudBandejaAvpt: f.idSolicitudBandejaAvpt,
                  nombreEmpleado:f.nombreEmpleado,
                  descripcionEstatus: f.descripcionEstatus,
                  empleadoAccion: f.empleadoAccion
                }); */
                
              });
            }else{
              this.listaHistoricoAcciones = [];
              this.listaHistoricoAccionesIndexAgregado = [];
            }
          }).finally(() => {
            if (isHistorialActividad) {
              this.mostrarModalHistoricoAcciones=true;
            }
        
      });
    },
    cambioFiltro(tipoFiltro){
      if(tipoFiltro === 1){ //filtro por fechas
        this.filtro.idPaciente  = null;
        this.filtro.idPTI = null;
      }else if(tipoFiltro === 2){ //filtro de pti
        this.filtro.clinica = [];
        this.filtro.fechaInicio = null;
        this.filtro.fechaFin = null;
        this.filtro.idPaciente  = null;
        this.todas =true;
      } else if(tipoFiltro === 3){ //filtro por px
        this.filtro.clinica = [];
        this.filtro.fechaInicio = null;
        this.filtro.fechaFin = null;
        this.filtro.idPTI = null;
        this.todas =true;
      }
    }
  },
  watch: {
    currentPage() {
      this.getNotifications(this.currentPage, true);
    },

    tipoBusqueda: function () {
      this.setearDatos();
    },
  }
};
</script>

<style scoped>
.bCardGlobal {
  margin: 2% 4% 2% 4%;
  padding: 0.5% 1% 0.5% 1%;
  border-radius: 20px;
}

.divSubtitulo {
  width: 100%;
  margin-top: 2%;
  margin-bottom: 2%;
  border-bottom: 5px solid #8ec6e9;
}

.divInput {
  margin-left: 1%;
  margin-right: 3%;
}

.textSubtitulo {
  color: #093974;
  font-weight: 600;
  font-size: 22px;
  text-align: left;
}

.overflow-ellipsis {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.scroll-area {
  position: relative;
  margin: auto;
  height: 500px;
}

.barra {
  border-width: 1px;
  border-style: solid;
  border-color: #c2e7ff;
  background: #ffffff;
  margin: 1rem;
  padding: 5px;
  border-radius: 6px;
  text-align: left;
  align-items: center;
  width: 70%;
  justify-content: center;
}
</style>
